import { render, staticRenderFns } from "./SummerSection.vue?vue&type=template&id=5fb891c8&"
import script from "./SummerSection.vue?vue&type=script&lang=js&"
export * from "./SummerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports